import { render, staticRenderFns } from "./cly-color-tag.vue?vue&type=template&id=ad8e19b2"
import script from "./cly-color-tag.vue?vue&type=script&lang=js"
export * from "./cly-color-tag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports